module.exports = __webpack_public_path__ + "metabase.svg?6476364d39ff0a35291233980982efcd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/metabase.svg
// module id = 295
// module chunks = 2